var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _tspan, _path9, _tspan2, _path10, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCcLandingPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5114856-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\ttspan { white-space:pre } \r\n\t\t.s0 { fill: #2f70e0 } \r\n\t\t.s1 { fill: none;stroke: #bbbfbd;stroke-miterlimit:10;stroke-width: 2 } \r\n\t\t.s2 { fill: #ffffff } \r\n\t\t.s3 { fill: none;stroke: #bbbfbd;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \r\n\t\t.s4 { fill: #d9d9d9 } \r\n\t\t.t5 { font-size: 36px;fill: #000000;font-weight: 400;font-family: \"Alatsi-Regular\", \"Alatsi\" } \r\n\t\t.s6 { fill: #99c6ab } \r\n\t\t.t7 { font-size: 36px;fill: #ffffff;font-weight: 400;font-family: \"Alatsi-Regular\", \"Alatsi\" } \r\n\t\t.s8 { fill: #feffff } \r\n\t\t.s9 { fill: #aed6be } \r\n\t\t.s10 { fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \r\n\t\t.s11 { fill: #ff996a } \r\n\t\t.s12 { fill: #d3aa7d } \r\n\t\t.s13 { fill: #c1966b } \r\n\t\t.s14 { fill: #649176 } \r\n\t\t.s15 { fill: #7eaf92 } \r\n\t\t.s16 { fill: #ffd294 } \r\n\t\t.s17 { fill: #d37a57 } \r\n\t\t.s18 { fill: #3f2d1f } \r\n\t\t.s19 { fill: #9c897a } \r\n\t\t.s20 { fill: #77a58a } \r\n\t\t.s21 { fill: #e5bc89 } \r\n\t\t.s22 { fill: #527a62 } \r\n\t\t.s23 { fill: none;stroke: #9c897a;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \r\n\t\t.s24 { fill: none;stroke: #e5bc89;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \r\n\t\t.s25 { fill: none;stroke: #543e2f;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \r\n\t\t.s26 { fill: #aed6bd } \r\n\t\t.s27 { fill: #363636;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \r\n\t\t.s28 { fill: #000000;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \r\n\t\t.s29 { fill: #fdfdfd } \r\n\t\t.s30 { fill: #847062 } \r\n\t\t.s31 { fill: none;stroke: #847062;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECT"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m465.3 238.2c0 0-112.9 4.9-172.7 123-59.9 118.1-121.6 81.3-158.1 187.8-36.5 106.5 37.1 227.6 86.4 240.8 49.3 13.1 612.5 0 612.5 0 0 0 74.4-50.9 80.3-183.1 5.8-132.1-105.1-176.3-151-195.1-46-18.8-116.8-176.3-297.4-173.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m626.1 560.1c130.1-87.5 155.4-132.5 219.6-140.8 156.4-20.4 41.8 383.9-316.4 470.3-170.1 41-380.9-70.9-411-157.9-29.2-84.1 49.3-115.6 165.1-70.5 115.9 45.1 276.5-56.5 342.7-101.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m784 460.3c0 10.9-8.8 19.8-19.8 19.8-10.9 0-19.8-8.9-19.8-19.8 0-10.9 8.9-19.8 19.8-19.8 11 0 19.8 8.9 19.8 19.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m776 849.5c0 11-8.8 19.8-19.8 19.8-10.9 0-19.8-8.8-19.8-19.8 0-10.9 8.9-19.8 19.8-19.8 11 0 19.8 8.9 19.8 19.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m518.1 398.9c0 11-8.9 19.8-19.9 19.8-10.9 0-19.8-8.8-19.8-19.8 0-10.9 8.9-19.8 19.8-19.8 11 0 19.9 8.9 19.9 19.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m442.2 478.1l-20.1 27.9h38.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m347.8 833.4l-12.7 24.3h38.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m161.5 525.6c0 20.9-16.9 37.8-37.8 37.8-20.8 0-37.7-16.9-37.7-37.8 0-20.8 16.9-37.8 37.7-37.8 20.9 0 37.8 17 37.8 37.8z"
  })), /*#__PURE__*/React.createElement("text", {
    id: "?",
    style: {
      transform: "matrix(2,0,0,2,109.119,553.329)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t5"
  }, "?\r\n")))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m550.7 249.4c0 20.9-17 37.8-37.8 37.8-20.9 0-37.8-16.9-37.8-37.8 0-20.9 16.9-37.8 37.8-37.8 20.8 0 37.8 16.9 37.8 37.8z"
  })), /*#__PURE__*/React.createElement("text", {
    id: "? ",
    style: {
      transform: "matrix(2,0,0,2,498.245,277.085)"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t7"
  }, "?\r\n"))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m241 541.4c0 10.6-8.5 19.1-19 19.1-10.5 0-19-8.5-19-19.1 0-10.5 8.5-19 19-19 10.5 0 19 8.5 19 19z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m728.4 259.6h162.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m896.2 201.3h-170.3c-9.7 0-17.6 7.9-17.6 17.6v102.5c0 9.7 7.9 17.6 17.6 17.6h34.7l-6.9 17.8c-2 5.1 3.9 9.7 8.4 6.4l32.9-24.2h101.2c9.7 0 17.6-7.9 17.6-17.6v-102.5c0-9.7-7.9-17.6-17.6-17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m728.4 230h162.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m728.4 244.8h162.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m728.4 259.6h162.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m728.4 274.4h162.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m728.4 289.2h162.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m728.4 304h162.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m363.7 527.1c0 0-1.8-14.5-4-21.4-2.3-7-11.8-20.2-11.8-20.2 0 0-3.8 8.2 1.7 15 0 0-0.3 10.7 0.2 14.5 0 0-18-15.4-21.5-16.9-2.2-1.8-4.8-3.9-8.1-6.5-12-9.6-20-6.6-18.9-5.9 0.7 0.4 14.4 11.5 22.8 18.4l-1.1 1.5c-2.5-2-6.6-5.3-12.7-10.1-12-9.5-19.9-6.6-18.9-5.9 0.9 0.6 20.9 16.8 27.4 22.1l-1.9 2.7c-2.5-2-6.7-5.3-13.2-10.5-11.9-9.5-19.9-6.6-18.9-5.9 0.9 0.6 21.9 17.6 27.9 22.5l-2.1 2.9c-2.2-2-8.4-7.5-14.3-11.7-7.5-5.2-12.9-2.8-12.9-2.8 0 0 0 0 3.3 3 3.3 2.9 20.5 16.5 20.5 16.5 0 0 26.2 23.4 32.8 25.6l6.4 6.1 23.5-25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m552.3 688.8c-14.1 20.2-33.8 32.8-59.9 27.4-70.1-14.2-152.8-150.2-152.8-150.2l4.2-4.5 30.9-33.3 107.4 97.6 33.5-48.6 32.8-47.4 16.2-23.4c0 0 9.5 14.9 15.4 62.6 3.8 29.9-4.1 85.7-27.7 119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m552.3 688.8c-14.1 20.2-33.8 32.8-59.9 27.4-70.1-14.2-152.8-150.2-152.8-150.2l4.2-4.5 2.6-1.4c0 0 98.5 135.6 140 115.4 25.7-12.4 29.8-62.1 29.2-98.3l32.8-47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m815.3 675.5l-6.4 112.4h-24.7l9.7-112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m663.9 675.5l-6.4 112.4h-24.8l9.8-112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m817.9 695h-196.1c-19.5 0-35.3-15.8-35.3-35.3v-109.7c0-19.5 15.8-35.3 35.3-35.3h196.1c19.5 0 35.2 15.8 35.2 35.3v109.7c0 19.5-15.7 35.3-35.2 35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m801.3 695h-196c-19.5 0-35.3-15.8-35.3-35.3v-109.7c0-19.5 15.8-35.3 35.3-35.3h196c19.5 0 35.3 15.8 35.3 35.3v109.7c0 19.5-15.8 35.3-35.3 35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m653.5 464.1c0 0 38.7-6.2 90.7 47.6l12 276.2h-217.4c0 0-23.7-186.3 4-252.6 27.6-66.2 77.3-74.1 110.7-71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m577.7 314.4l9.5-13.1 81.4 27.2-0.7 30.6h5.4c10.9 0 19.8 8.9 19.8 19.8 0 10.9-8.9 19.7-19.8 19.7h-6.3l-1 41.5v36.5l-58.9 8.1-1.4-24.4-0.8-12.8-8.5-4.1c-24.5-11.7-40.1-36.4-40.1-63.5 0-23.6 7.5-46.5 21.4-65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m604.9 447.5l0.8 12.8q3.2-0.4 6.8-1c36.4-6.6 50.6-39.5 49.1-56.5 0 0-12.2 40.8-56.7 44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m673.9 373.2c-1.5 1.2-2.9 2.7-3.4 4.6 0 0 3 1 3.3 4.4 0.3 3.4-3.3 4.9-3.3 4.9 0 0 2.7 4.6 7.3 2.1 4.6-2.5 3.9-11.1-0.7-13 0 0 7.3-0.8 9.9 1.9 0 0 0.6-2.7-2.4-5.1-3.1-2.4-7.5-2.2-10.7 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m577.7 314.4c0 0 11 18.9 25.3 25.1 14.2 6.1 29.4-2.8 43.7 5.3 14.2 8.2 5.1 23.5 8.3 30.8 3.2 7.3 6.7 8.3 6.7 8.3 0 0 1.9-20.9 6.2-24.8 0 0 12.8-0.1 16.8 3.6 0 0 7.1-14.4 8.4-25.7 1.2-11.3-11.3-15-11.3-15 0 0-3-27-36.1-37-33.2-10.1-58.5 5.9-71.7 0-13.3-5.9-25.3 2.9-26 16.3-0.8 13.4 8.3 18.3 8.3 18.3 0 0-6.1 5.2-3.7 13.1 2.5 8 10.2 9.8 10.2 9.8 0 0 9.1-20.2 14.9-28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m584.3 411.4l33.7-1.6c0 0-7.8 12.1-18.9 12-10.2-0.1-14.8-10.4-14.8-10.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m676.8 467l-10.6-13.9-42.4 15-6.9 11.9-4.7-10.7-6.4-7-6.7 12.8c0 0 0.2 13 16.6 16.4 16.3 3.4 52.1-9.9 61.1-24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m684.7 362.7c0 0-6.6-2.5-12.9 3.3-6.2 5.7-4.1 11.4-4.1 11.4 0 0 2.9-6.8 9.1-6.1 6.2 0.8 10.7 17.5 2.4 20.6-8.3 3.2-18.9-1.6-18.5-14.5 0.4-12.9 5.1-20.2 12.9-21.3 7.8-1.1 10.9 5.4 11.1 6.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m626.1 427.6c-0.8 0-1.5-0.6-1.6-1.4-0.2-0.9 0.4-1.8 1.3-2 32.1-6.2 43-36.4 43.1-36.7 0.3-0.9 1.2-1.3 2.1-1 0.9 0.3 1.4 1.3 1.1 2.1-0.1 0.4-11.6 32.4-45.7 39q-0.1 0-0.3 0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m619 426.5c0 3.9 3.2 7.2 7.1 7.2 4 0 7.2-3.3 7.2-7.2 0-4-3.2-7.2-7.2-7.2-3.9 0-7.1 3.2-7.1 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m676 374.4c0 0-0.9 7.9 0.8 12.2 1.7 4.2 4.5 2 5-3.1 0.5-5.2-4.6-12.4-5.8-9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m460 787.9c0 0-0.7-21.5 23.6-28.3 24.2-6.7 53.8 13 58.5 28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m804 719.3c-6.2 18.5-17.4 32.5-30.7 42.4-9.1 6.7-19.1 11.5-29.1 14.5-41.7 12.7-196.3 11.7-196.3 11.7l5.8-46.7 173.1-38.9c0 0-22.4-71-21.4-128.4 0.9-53.4 16.8-75.4 34.8-65q2 1.1 4 2.8c0 0 27.4 40.8 55.6 124.4 11.5 34.2 11.3 61.8 4.2 83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m536.1 747.4l-36.7-6.7c0 0-6.7-1.2-13.5 1.8-6.7 2.9-14.4 17.1-14.4 17.1 0 0 6.2 0.1 10.4-3.7 4.2-3.8 4.8-7 4.8-7l13.4 1 0.3 3.1c-4.5 1-17.3 3.9-23.6 6.6-7.7 3.3-11.7 13.3-11.7 13.3 0 0 10.1-1.4 15.2-7.6l20.8-2.4 0.2 1.9c-4.3 0.3-12 1.3-19.2 4.5-10.8 4.7-14.1 11.1-14.1 11.1 0 0 10.8 0 18.4-5.8l5.1-0.5c-5.1 3.3-9.4 11-9.4 11 0 0 2.2 0.6 7.1-1.6 4.9-2.2 6.2-4.7 6.2-4.7l14.4 1.1c7.4 1.1 18.7 2.1 25.1 0l13.8 2.1 4.3-34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m841.8 810.5h-690.5c-6.2 0-11.3-5.1-11.3-11.3 0-6.2 5.1-11.3 11.3-11.3h690.5c6.3 0 11.3 5.1 11.3 11.3 0 6.2-5 11.3-11.3 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m577.2 810.5h-430.4c-3.7 0-6.8-5.1-6.8-11.3 0-6.2 3.1-11.3 6.8-11.3h215.2 215.2c3.7 0 6.7 5.1 6.7 11.3 0 6.2-3 11.3-6.7 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m447 744.4h-237.8c-8 0-14.9-5.6-16.7-13.5l-30.7-139.6c-1.5-6.8 3.7-13.3 10.7-13.3h240.5c7.1 0 13.3 5 14.8 11.9l30.8 140c1.6 7.4-4 14.5-11.6 14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m248.2 720.7c-2 10-13.6 16.1-26.1 13.7-12.4-2.5-20.8-12.6-18.8-22.6 1.9-10 13.6-16.1 26-13.7 12.4 2.5 20.9 12.6 18.9 22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m458.6 729.9l-30.8-140c-1.5-6.9-7.7-11.9-14.8-11.9h-13.9c7.1 0 13.3 5 14.8 11.9l30.9 140c1.6 7.4-4.1 14.5-11.6 14.5h13.8c7.6 0 13.2-7.1 11.6-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m417.5 782.3c0 3.1-2.5 5.6-5.6 5.6h-197.4c-3.2 0-6.1-1.3-8.2-3.4-2.1-2.1-3.3-4.9-3.3-8.1 0-2.3 0.6-4.5 1.9-6.4l48.9-73.2c1.4-2 3.7-3.3 6.2-3.3h85.4c3 0 5 3.4 3.4 6l-41.2 71.3c-1.6 2.6 0.3 5.9 3.4 5.9h100.9c1.5 0 2.9 0.6 3.9 1.6 1 1 1.7 2.4 1.7 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m358.9 660.2h-121.2c-1.4 0-2.5-1.1-2.5-2.5 0-1.5 1.1-2.6 2.5-2.6h121.2c1.4 0 2.5 1.1 2.5 2.6 0 1.4-1.1 2.5-2.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m364.7 675.5h-121.1c-1.4 0-2.6-1.1-2.6-2.5 0-1.4 1.2-2.6 2.6-2.6h121.1c1.4 0 2.5 1.2 2.5 2.6 0 1.4-1.1 2.5-2.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m164.3 586.3h256.5c2.1 0 4.1 0.4 5.9 1.1-2.3-5.6-7.8-9.4-14-9.4h-240.5c-5.3 0-9.6 3.8-10.7 8.6q1.4-0.3 2.8-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m427.8 720.7c-2 10-13.7 16.1-26.1 13.7-12.4-2.5-20.9-12.6-18.9-22.6 2-10 13.7-16.1 26.1-13.7 12.4 2.5 20.9 12.6 18.9 22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m417.4 782.7c-0.2 3-2.8 5.2-5.8 5.2h-112.4c-4.5 0-8.2-3.7-8.2-8.2 0-1.6 0.4-3.1 1.3-4.4l51.6-81.8h1.5c3 0 5 3.4 3.4 6l-41.2 71.3c-1.6 2.6 0.3 5.9 3.4 5.9h100.9c1.5 0 2.9 0.6 3.9 1.6 1.1 1.1 1.8 2.7 1.6 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m744.2 776.2c-41.7 12.7-196.3 11.7-196.3 11.7l199.7-53.2c20.9-5.5 34.2-25.9 30.8-47.3-8.8-55.2-25.7-154.2-38.2-178.5q2 1.1 4 2.8c0 0 27.4 40.8 55.6 124.4 28.2 83.7-13.8 127.5-55.6 140.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m732.4 704.2c0 0 28.6-0.4 51.8 20.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m672.7 472c0 0 37.6 12.8 56.1 34.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m485.6 632.2c0 0 20.8 26.8 23.4 57.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m593 475.3c0 0-7.9 22.2 25 24.9 33 2.7 69.1-29.6 69.1-29.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m547.9 747.4l-7.7 33.3 8.5 1.3 4.3-34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m615.7 491.5c0 0-9.8 27.9-16.6 99.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m678.8 322.4c0 0-15.4-3.7-29.3 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m577.7 314.4c0 0-1.6 22.5 27 25.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m681.3 307.5c0 0 3.3 9 0.5 14.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m552.2 298.4c0 0-1.3 13.8 12.8 19.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m557.3 324.1c0 0-2.6 10.3 7.2 14.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m603 288.7c0 0 18.2-8 44.1 3.7 23.4 10.5 25.6 23.5 25.6 23.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m681.3 327.9c0 0 5.2 2.5 5.2 9.7 0 7.3-3.6 14.8-3.6 14.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m595.7 325.4c0 0 3.6 9.6 24.8 10.7 21.2 1 28.1 1 33.9 7.9 5.8 6.9 3.8 14.4 3.8 14.4"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m587.7 101.7h-193.1c-11.1 0-20.2 9-20.2 20.2v33.1c0 11.1 9.1 20.2 20.2 20.2h25.6l-5.9 20.6c-1.1 3.8 3.1 6.9 6.4 4.8l40.1-25.4h126.9c11.2 0 20.3-9.1 20.3-20.2v-33.1c0-11.2-9.1-20.2-20.3-20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m400.6 121.4h182.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m400.6 136.9h182.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m400.6 152.4h182.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m437.5 302.1c0 90.8-73.6 164.4-164.3 164.4-90.8 0-164.4-73.6-164.4-164.4 0-90.8 73.6-164.4 164.4-164.4 90.7 0 164.3 73.6 164.3 164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m427.1 302.1c0 57.5-31.5 107.6-78.1 134-5.2 3-10.6 5.7-16.2 8-18.4 7.7-38.5 12-59.6 12q-2.1 0-4.2-0.1-1.3 0-2.6-0.1-0.9 0-1.8-0.1-1.4 0-2.7-0.1-0.6-0.1-1.2-0.1c-1-0.1-2.1-0.2-3.2-0.3q-1.8-0.2-3.6-0.4l38-55.1-101.1-109.6-66 53.3q-1-3.7-1.9-7.5-0.3-1.4-0.6-2.9-0.4-1.8-0.7-3.7-0.2-1.3-0.4-2.5-0.3-1.8-0.6-3.7-0.1-1-0.2-2-0.2-1.6-0.4-3.2l-0.1-0.6q-0.1-1.7-0.3-3.4-0.1-2-0.2-3.9v-0.1q-0.1-1.9-0.2-3.9 0-2 0-4c0-25.6 6.2-49.7 17.2-70.9 22.9-44.1 66.6-75.7 118-81.9q9.2-1.1 18.8-1.1c25.8 0 50.2 6.3 71.6 17.6l-67.1 54.2 44.8 135.7 86.8-125.5c11.4 21.4 17.8 45.9 17.8 71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m136 231.1l54.4 58.9-66 53.4q-1-3.7-1.9-7.5-0.3-1.5-0.6-2.9-0.4-1.9-0.7-3.8-0.2-1.2-0.4-2.5-0.3-1.8-0.6-3.6-0.1-1-0.2-2-0.2-1.6-0.4-3.2l-0.1-0.6q-0.1-1.8-0.3-3.5-0.1-1.9-0.2-3.8v-0.1q-0.1-2-0.2-4 0-1.9 0-3.9c0-25.6 6.2-49.7 17.2-70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m332.4 444c-18.4 7.7-38.5 11.9-59.6 11.9q-2.2 0-4.2 0-1.3 0-2.6-0.1-0.9 0-1.8-0.1-1.4-0.1-2.7-0.2-0.6 0-1.2-0.1c-1 0-2.1-0.1-3.2-0.2q-1.8-0.2-3.6-0.5l38-55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m344.4 165.7l-67.1 54.1-23.3-70.7q9.2-1.1 18.8-1.1c25.8 0 50.2 6.4 71.6 17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m426.7 302c0 57.4-31.5 107.5-78.1 134l-26.5-80.4 86.8-125.6c11.4 21.5 17.8 46 17.8 72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m291.5 399.7l-38 55q-1.5-0.1-2.9-0.4-1.2-0.1-2.4-0.3-1.4-0.2-2.7-0.5-1.8-0.3-3.5-0.6-1.6-0.3-3-0.7-1-0.2-1.9-0.4-1.3-0.3-2.5-0.6-4.1-1.1-8.1-2.3-1.4-0.5-2.9-1-1.9-0.6-3.8-1.3-1.8-0.6-3.5-1.3-1.8-0.7-3.5-1.5-1.7-0.7-3.4-1.4 0 0 0-0.1-1.7-0.7-3.4-1.5-5.1-2.5-10-5.3-1.6-0.9-3.1-1.8-3.2-2-6.2-4.1-1.6-1-3.1-2.1-1.5-1-3-2.2 0 0-0.1 0-1.4-1.1-2.8-2.2-1.2-1-2.4-1.9-1.8-1.5-3.5-3-1.3-1.1-2.6-2.3-1.3-1.1-2.5-2.3-0.2-0.2-0.3-0.3-1.3-1.2-2.5-2.5-1.1-1-2.2-2.2-1.5-1.5-2.9-3.1-1.3-1.4-2.5-2.8-0.9-1.1-1.8-2.2-0.6-0.6-1.1-1.3-0.9-1.1-1.8-2.2-1-1.2-1.9-2.5-1.3-1.7-2.5-3.4-1.1-1.5-2.1-3-0.7-1.1-1.5-2.2-0.4-0.7-0.8-1.4-2-3-3.8-6.2-0.8-1.4-1.6-2.9-1.9-3.5-3.6-7.1-0.7-1.4-1.4-3-0.7-1.6-1.4-3.2-0.1-0.1-0.1-0.2-0.7-1.7-1.4-3.4 0-0.1-0.1-0.1-0.6-1.7-1.3-3.5-0.6-1.6-1.2-3.4-0.5-1.5-1-3-0.3-1.2-0.7-2.3 0-0.1 0-0.2-0.4-1.3-0.8-2.6l66-53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m408.9 230l-86.8 125.6-44.8-135.8 67.1-54.1c27.4 14.4 50 36.9 64.5 64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m322.1 355.6l-30.6 44.1-101.1-109.7 86.9-70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m301.3 280.6l0.4-8.1 5.4-2.6c15.5-7.4 25.4-23.1 25.4-40.2 0-14.9-4.7-29.4-13.5-41.5l-6.1-8.3-51.5 17.3 0.5 19.3h-3.4c-6.9 0-12.5 5.6-12.5 12.5 0 6.9 5.6 12.5 12.5 12.5h4l0.6 26.3v9.2c0 0-9.3 9-27 16.6 0 0 19.7 24.7 52.2 26.3 32.5 1.6 33.8-17.9 33.8-17.9 0 0-13.5-8.1-21.2-14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m301.7 272.5l-0.4 8.1q-2.1-0.3-4.3-0.7c-23.1-4.2-32.1-25-31.1-35.7 0 0 7.7 25.8 35.8 28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m258.1 225.5c1 0.7 1.8 1.6 2.2 2.9 0 0-2 0.6-2.1 2.8-0.2 2.1 2.1 3 2.1 3 0 0-1.8 3-4.7 1.4-2.9-1.6-2.4-7.1 0.5-8.2 0 0-4.6-0.6-6.3 1.1 0 0-0.4-1.7 1.5-3.2 2-1.5 4.8-1.4 6.8 0.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m311.3 248.3c0 0-9 0.3-12.7 3.7-3.7 3.3 9.9 4.3 12.7 3 2.9-1.3 4.1-7.1 0-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m338.3 311.9c0 0 28.8 52.7 39.8 96.9l-29.7 17.3c0 0-11.8-23.6-15.9-59.9-4.1-36.2 5.8-54.3 5.8-54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m322.1 192.9c0 0-28.8 27.2-55.2 24.2 0 0-2.8 19.2 1.9 26.5 0 0-2 2-4.9-5.6-2.8-7.7-0.6-18.3-2-21.5 0 0-8.8-2.1-14.6 6.9-5.8 8.9 6.9 19.9 15.2 18.1l0.3 16.5c0 0-9.4 3.5-17.5-3.3-8-6.7-4-13.7-4-13.7 0 0-12.1-11.9-12.7-28.5-0.5-16.5 13.3-26.9 13.3-26.9 0 0 4.5-24.5 34.8-24.8 30.3-0.3 39.1 8.8 39.1 8.8 0 0 19.5 3.3 25 24.1 5.6 20.8-8.3 31.9-8.3 31.9 0 0-4-26.6-10.4-32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m247 182.7c0 0-1.5-17.8-18.4-17-16.9 0.7-20.1 20.1-12.8 29 7.3 9 16.9 7 24 0 7.2-6.9 7.2-12 7.2-12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m269 252.7l-10.6 22.2c-0.4 0.8-1.4 1-2.1 0.5l-0.5-0.3-34.8-27c-0.6-0.4-0.7-1.1-0.4-1.8l12-22 0.3-0.5c0.4-0.8 1.4-0.9 2.1-0.4l33.6 27.7c0.5 0.4 0.7 1.1 0.4 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m342.4 439.5c-20.8 10.5-44.3 16.4-69.2 16.4-20.6 0-40.1-4-58-11.3l-11.4-130.4c0 0 2.3-9 16.3-14.1 15.8-5.9 16-6.5 16-6.5 60.4 30.4 86 8.4 86 8.4l13.3 6.7c1.3 0.7 2.3 1.8 2.9 3.2 3.1 7.5 13.5 33.5 14.6 51.4 0.8 14.3-6 52.8-10.5 76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m210.5 305.4c0 0-14.8 5.8-20.1 44.4-5.3 38.5 0.4 59 0.4 59l29.3-34.9c0 0 10-53.3-9.6-68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m254.3 249c-2.9 1.6-10.2 6.7-11.5 8.9-0.6 1-0.9 2.2-1 3.2l-1.8-1c0.9-3.9 2.6-7.9 2.6-7.9 0 0 2.9-1.6 4.6-3.9 1.6-2.3 1-4.1 1-4.1-1.1 0.6-2.9 1.8-4.8 3.1q0.1 0 0.1-0.1c1.6-2.3 1-4.1 1-4.1-2.9 1.6-10.5 7-11.9 9.2-0.7 1.2-0.9 2.6-1 3.6l-0.5-0.2c0.8-4.2 2.8-8.7 2.8-8.7 0 0 2.9-1.6 4.5-3.9 1.6-2.3 1-4.1 1-4.1-2.9 1.7-10.5 7-11.8 9.2-1.4 2.3-1.1 5.2-1.1 5.2l1.1 19.1 1 21.1c0 0-38.6 88.5-38.2 110.1 0.4 21.6 13.4 30.1 13.4 30.1 0 0 13.8-1.6 22.7-15.2 8.8-13.7 16.9-117.6 16.9-117.6 0 0 4.7-7 5.5-13.8 0.8-6.7-2.3-23.8-2.3-23.8 0.9-3.5 2.3-6.7 2.3-6.7 0 0 2.8-1.5 4.4-3.7 1.5-2.2 1-4 1-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m269 252.7l-10.6 22.2c-0.4 0.8-1.4 1-2.1 0.5l-0.5-0.3 10.8-23.2-34-27.6 0.3-0.5c0.4-0.8 1.4-0.9 2.1-0.4l33.6 27.7c0.5 0.4 0.7 1.1 0.4 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m232.6 228.7l-1.5 2.9 7.4 6 1.6-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m444.6 316.1l-8.2 1.6-0.2-0.8c2.4-0.8 8-3 10.2-6.4 2.9-4.3 3.9-8.5 3.9-8.5 0 0-5 2.6-6.9 7.6l-3.9 0.7c1.5-0.9 3-2.1 3.9-3.5 2.9-4.3 3.9-8.5 3.9-8.5 0 0-5 2.6-7 7.6l-4.9 1c2.1-1.6 4.2-3.7 5.1-6 1.9-4.9 2-9.2 2-9.2 0 0-4.3 3.6-5.2 9l-5.4 2.2-23.6 7.4 0.2-3.4c0 0 0.9-0.5 3.4-2.5 2.5-2 5.6-10.1 5.6-10.1 0 0-12.4 5.8-15.4 12.2-3 6.4-5.9 22.3-5.9 22.3 0 0-28.4 68.3-33.4 87.1 0 0-9.8 3.8-14.4 10.2 0 0 9.9 18.2 17.8 20.1 0 0 22.8-4.4 33.6-31 10.9-26.6 15.3-80.3 15.3-80.3l22.8-12.5c0 0 6.9-2 9.2-5.5 2.4-3.6 3.2-7 3.2-7 0 0-4.1 2.1-5.7 6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m343.1 393.6c0 0-13.4-2.5-36.2-2.5-22.9 0-45.7 4.3-45.7 4.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m319 176.8c0 0 3.7 6.8 3.4 11.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m313.4 171.6c0 0-14.9 4.9-23.2 16.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m244.2 179.2c0 0-2.5 5.4-2.6 7.4 0 0-8 7.5-9 11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m214.2 199.4c0.5 0.4 8.4 6.4 16.5 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m254 176.8c0 0 18.5-17.1 49.2-8.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m257.7 212c0 0 8 3.2 25 0 17-3.2 32.5-20.6 32.5-20.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m250.9 305.4c0 0 23.2 9.7 47 8.2 23.8-1.4 26.8-5.7 26.8-5.7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcLandingPage);
export default __webpack_public_path__ + "static/media/CC-Landing Page.de87fb816a6887df14b8ce0bbcd36d86.svg";
export { ForwardRef as ReactComponent };